import { Component } from '@angular/core';
import { IonicPage, LoadingController, ToastController, NavController, NavParams, reorderArray } from 'ionic-angular';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SERVER_URL } from "../../config";
import { Storage } from "@ionic/storage";
import { AuthProvider } from "../../providers/auth/auth";
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { AddcategoriaPage } from '../addcategoria/addcategoria';
import { ArticoliPage } from '../articoli/articoli';


/**
 * Generated class for the CategoriePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-categorie',
  templateUrl: 'categorie.html',
})
export class CategoriePage {

  item;
  aut;
  categorie: string[];
  errorMessage: string;
  link = SERVER_URL + "/manifesti/files/"

  user;
  constructor(params: NavParams, private readonly loadingCtrl: LoadingController,
    private readonly httpClient: HttpClient,
    private readonly storage: Storage,
    authProvider: AuthProvider,
    public rest: RestApiProvider,
    public nav: NavController
  ) {

    this.item = params.data.item;
    this.aut = authProvider;
   
  }



  private handleResponse(resp: string) {
    console.log("RESP:" + resp);
    return " ";

  }

  getCategorie() {
    this.rest.getCategorie()
      .subscribe(
        categorie => this.categorie = categorie,
        error => this.errorMessage = <any>error);
  }

  ionViewDidLoad() {
    console.log('getCategorie');
    this.getCategorie();
    console.log("_________________________________________________this.categorie"+JSON.stringify(this.categorie));
    this.storage.get('user').
    then((value) => {
      this.user = value;
      console.log(" constructor indirizzo STOREEEEEEEEEEEEEEEEEEEE:" + JSON.stringify(this.user))

    })
  }

  openArticoliPage(categoria) {
    console.log("openArticoliPage:" + JSON.stringify(categoria));

    this.nav.push(ArticoliPage, { categoria: categoria });


  }
  openAddcategoriaPage() {

    this.nav.push(AddcategoriaPage);

  }
  reorderItems(indexes) {
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.categorie = reorderArray(this.categorie, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.categorie));
    var i = 0;
    this.categorie.forEach(function (element) {

      console.log(element["name"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.categorie));



    this.rest.aggiornaListCategoria(this.categorie);

  }

}



// WEBPACK FOOTER //
// ./src/pages/categorie/categorie.ts